export default {
  '"Email" must be a Email': 'Please provide a valid email address',
  '"Telephone" Must start with 0 and contain only numbers.': 'The telephone number you have provided is invalid',
  '"Telephone" must have no more than 11 characters': 'UK telephone numbers should contain 10 or 11 digits',
  '"Telephone" must have at least 10 characters': 'UK telephone numbers should contain 10 or 11 digits',
  '"Sort code" must have no more than 6 characters': 'Please enter a valid sort code',
  '"Account holder name(s)" is required': 'Please enter your account holder name(s)',
  '"Account number" is required': 'Please enter a valid account number',
  '"How did you hear about Sovereign Health Care?" is required': 'Please indicate how you heard about us',
  '"Title" is required': 'Please provide your title',
  '"First name(s)" is required': 'Please provide your first name(s)',
  '"Surname" is required': 'Please provide your surname',
  '"Date of birth" is required': 'Please provide your date of birth',
  '"Email" is required': 'Please provide your email address',
  '"Telephone" is required': 'Please provide your telephone number',
  '"Postcode" is required': 'Please provide your postcode',
  'Sort code is not on file': 'Please enter a valid sort code and account number',
  'Please check the box highlighted to agree to our terms and conditions': 'Please ensure you have ticked the box indicating you have agreed to our terms and conditions',
  '"Address" is required': 'Please provide your address',
  '"Mobile" Must start with 0 and contain only numbers.': 'The mobile number you have provided is invalid',
  '"Mobile" must have no more than 11 characters': 'The mobile number you have provided is invalid',
  '"Mobile" must have at least 10 characters': 'The mobile number you have provided is invalid'
}



// WEBPACK FOOTER //
// ./src/config/errors.js